import { Checkbox, type ColumnDefinition, Table } from '@approvalmax/ui/src/components';

import { getRoles } from '../../../../personsBasic/resources/components/PersonsTable/PersonsTable.helpers';
import { messages } from './SettingsTable.messages';
import type { EnrichedPerson } from './SettingsTable.types';

export const columns: ColumnDefinition<EnrichedPerson>[] = [
    {
        id: 'name',
        name: messages.name,
        sortable: false,
    },
    {
        id: 'roles',
        name: messages.role,
        sortable: false,
        width: 100,
        value: (item) => getRoles(item.roles),
    },
    {
        id: 'verifyNeeded',
        name: messages.verification,
        sortable: false,
        width: 80,
        textAlign: 'center',
        cellComponent: (props) => (
            <Table.FormCell
                name={`people.persons.${props.item.index}.verifyNeeded`}
                disabled={props.item.verifyNeededDisabled}
                {...props}
            >
                {({ ref, name }) => (
                    <Checkbox
                        ref={ref}
                        name={name}
                        disabled={props.item.verifyNeededDisabled}
                        onChange={(value) => {
                            props.item.onCheckVerifyNeeded(props.item, value);
                        }}
                    />
                )}
            </Table.FormCell>
        ),
    },
    {
        id: 'isWalletOwner',
        name: messages.walletOwner,
        sortable: false,
        width: 90,
        textAlign: 'center',
        cellComponent: (props) => (
            <Table.FormCell
                name={`people.persons.${props.item.index}.isWalletOwner`}
                disabled={props.item.isWalletOwnerDisabled}
                {...props}
            >
                {({ ref, name }) => (
                    <Checkbox
                        ref={ref}
                        name={name}
                        disabled={props.item.isWalletOwnerDisabled}
                        onChange={(value) => {
                            props.item.onCheckIsWalletOwner(props.item, value);
                        }}
                    />
                )}
            </Table.FormCell>
        ),
    },
];
